import React, { useEffect, useState } from "react";
import {
  MuiPickersUtilsProvider,
  DateTimePicker,
  DatePicker,
  TimePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "moment-timezone";
import { TemplateDataTypeEnum } from "../../enum/Template.enum";
import DateTimeFormatter, {
  defaultTimeForamt,
  defaultDateFormat,
  defaultDateTimeFormat,
} from "../../utils/DateFormatter";

const DateTimePickerInput = (props: any) => {
  const [value, updateValue]: any = useState("");

  useEffect(() => {
    if (!props.value) {
      updateValue(props.value);
    } else {
      let newValue: any = "";
      switch (props.type) {
        case TemplateDataTypeEnum.DATE:
          newValue = new Date(props.value);
          break;
        case TemplateDataTypeEnum.DATE_TIME:
          newValue = new Date(props.value);
          break;
        case TemplateDataTypeEnum.TIME:
          newValue = new Date("01/01/1970 " + props.value);
          //  newValue.setHours
          break;
      }
      updateValue(newValue);
    }

    // updateValue(DateTimeFormatter.convertDateTimeToSpecificFormat(props.value,'',format));
  }, [props.value]);

  const valueChangeFromPicker = (data: any) => {
    let newValue = "";
    switch (props.type) {
      case TemplateDataTypeEnum.DATE:
        newValue = data.format(defaultDateFormat);
        break;
      case TemplateDataTypeEnum.DATE_TIME:
        newValue = data.format(defaultDateTimeFormat);
        break;
      case TemplateDataTypeEnum.TIME:
        newValue = data.format(defaultTimeForamt);
        break;
    }

    setTimeout(() => {
      updateValue(newValue);
    });
    props.onChange(newValue);
  };

  const renderPickers = () => {
    switch (props.type) {
      case TemplateDataTypeEnum.DATE:
        return (
          <DatePicker
            clearable
            inputVariant={props.inputVariant || "outlined"}
            InputProps={{
              disableUnderline: props.disableUnderline || true,
            }}
            format={DateTimeFormatter.getDateFormat()}
            disablePast={props.disablePast || false}
            name={props.name}
            label={props.label}
            value={value || null}
            disabled={props.disabled !== undefined ? props.disabled : true}
            onChange={(data) => {
              setTimeout(() => {
                updateValue(data);
              });

              props.onChange(data, defaultDateFormat);
            }}
          />
        );
      case TemplateDataTypeEnum.DATE_TIME:
        return (
          <DateTimePicker
            clearable
            inputVariant="outlined"
            format={DateTimeFormatter.getDateTimeFormat()}
            name={props.name}
            label={props.label}
            value={value || null}
            disabled={props.disabled !== undefined ? props.disabled : true}
            onChange={(data) => {
              setTimeout(() => {
                updateValue(data);
              });

              props.onChange(data, defaultDateTimeFormat);
            }}
          />
        );

      case TemplateDataTypeEnum.TIME:
        return (
          <TimePicker
            clearable
            inputVariant="outlined"
            format={DateTimeFormatter.getTimeFormat()}
            name={props.name}
            label={props.label}
            value={value || null}
            disabled={props.disabled !== undefined ? props.disabled : true}
            onChange={(data) => {
              setTimeout(() => {
                updateValue(data);
              });

              props.onChange(data, defaultTimeForamt);
            }}
          />
        );
    }
  };
  return (
    <div className="input__box-container">
      <MuiPickersUtilsProvider utils={MomentUtils}>
        {renderPickers()}
      </MuiPickersUtilsProvider>
    </div>
  );
};
export default DateTimePickerInput;
